import { SVGProps, Ref, forwardRef } from 'react';

export const GraduationHatFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2 0 8.928l12 6.927 12-6.927zm0 15.934-8.5-4.907v.077c.008 1.57.1 3.737.982 5.036.394.581 1.345 1.223 2.852 2.094 2.034 1.176 3.344 1.766 4.652 1.77h.026c1.308-.003 2.619-.593 4.654-1.77 1.507-.871 2.458-1.513 2.852-2.094.877-1.291.973-3.441.982-5.01v-.103z"
                fill="currentColor"
            />
        </g>
    </svg>
));
GraduationHatFilledSize24Glyph.displayName = 'GraduationHatFilledSize24Glyph';
